import { render } from "./CharlaBurgerMenu.vue?vue&type=template&id=1ff388e4&scoped=true"
import script from "./CharlaBurgerMenu.vue?vue&type=script&lang=js"
export * from "./CharlaBurgerMenu.vue?vue&type=script&lang=js"

import "./CharlaBurgerMenu.vue?vue&type=style&index=0&id=1ff388e4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff388e4"]])

export default __exports__